import React from 'react'
// import config from '../../config'
import format from '../../helpers/format'
// import { Link, LinkIcon } from '../'

const EsgConfig = {
  esgNamesLabels: [
    {
      label: 'Private prison operators',
      value: 'pff_all_extreme_weight',
    },
    {
      label: 'Higher risk, prison industry',
      value: 'pp_high_weight',
    },
    {
      label: 'Higher risk, border industry',
      value: 'borders_high_weight',
    },
    {
      label: 'Higher risk, both',
      value: 'pff_all_high_weight',
    },
    {
      label: 'All screened, prison industry',
      value: 'pp_weight',
    },
    {
      label: 'All screened, border industry',
      value: 'borders_weight',
    },
    {
      label: 'All screened, both',
      value: 'pff_all_weight',
    },
    // {
    //   label: 'Gun manufacturers',
    //   value: 'gm_weight',
    // },
    // {
    //   label: 'Major gun retailers',
    //   value: 'gr_weight',
    // },
  ],
  esgOptions: {
    pff_all_extreme_weight: {
      id: 'pff_all_extreme_weight',
      icon: 'icons_step4',
      fieldLabel: 'pff_all_extreme_weight',
      benchLabel: 'pff_all_extreme_weight',
      valueLabel: 'Private prison operators',
      direction: 'ascending',
      page: 'pff-all-extreme-investments',
      label: 'in private prison operators',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in private prison operator companies
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in private prison operator companies
          </span>
        )
      }
    },
    pp_high_weight: {
      id: 'pp_high_weight',
      icon: 'icons_step4',
      fieldLabel: 'pp_high_weight',
      benchLabel: 'pp_high_weight',
      valueLabel: 'Higher risk, prison industry',
      direction: 'ascending',
      page: 'pp-high-investments',
      label: 'in higher risk companies, prison industry',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in higher risk companies, prisons
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in higher risk companies, prisons
          </span>
        )
      }
    },
    borders_high_weight: {
      id: 'borders_high_weight',
      icon: 'icons_step4',
      fieldLabel: 'borders_high_weight',
      benchLabel: 'borders_high_weight',
      valueLabel: 'Higher risk, border industry',
      direction: 'ascending',
      page: 'borders-high-investments',
      label: 'in higher risk companies, border industry',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in higher risk companies, borders
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in higher risk companies, borders
          </span>
        )
      }
    },
    pff_all_high_weight: {
      id: 'pff_all_high_weight',
      icon: 'icons_step4',
      fieldLabel: 'pff_all_high_weight',
      benchLabel: 'pff_all_high_weight',
      valueLabel: 'Higher risk, both',
      direction: 'ascending',
      page: 'pff-all-high-investments',
      label: 'in higher risk companies',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in higher risk companies
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in higher risk companies
          </span>
        )
      }
    },
    pp_weight: {
      id: 'pp_weight',
      icon: 'icons_step4',
      fieldLabel: 'pp_weight',
      benchLabel: 'pp_weight',
      valueLabel: 'All screened, prison industry',
      direction: 'ascending',
      page: 'pp-investments',
      label: 'in all screened prison industry companies',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in all screened prison companies
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in all screened prison companies
          </span>
        )
      }
    },
    borders_weight: {
      id: 'borders_weight',
      icon: 'icons_step4',
      fieldLabel: 'borders_weight',
      benchLabel: 'borders_weight',
      valueLabel: 'All screened, border industry',
      direction: 'ascending',
      page: 'borders-investments',
      label: 'in all screened border industry companies',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in all screened borders companies
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in all screened borders companies
          </span>
        )
      }
    },
    pff_all_weight: {
      id: 'pff_all_weight',
      icon: 'icons_step4',
      fieldLabel: 'pff_all_weight',
      benchLabel: 'pff_all_weight',
      valueLabel: 'All screened, both',
      direction: 'ascending',
      page: 'pff-all-investments',
      label: 'in all screened companies',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in all screened companies
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in all screened companies
          </span>
        )
      }
    },
    // wff_civ_weight: {
    //   id: 'wff_civ_weight',
    //   icon: 'icons_step4',
    //   fieldLabel: 'wff_civ_weight',
    //   benchLabel: 'wff_civ_weight',
    //   valueLabel: 'Civilian firearm',
    //   direction: 'ascending',
    //   page: 'civilian-firearm-investments',
    //   label: 'in civilian firearms',
    //   units: null,
    //   unitsExpanded: null,
    //   diffGood: (diff) => (diff < 0),
    //   diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
    //   moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
    //   format : (val) => format.perc(val),
    //   formatExpanded: (val, moreLess, postiveNegative, url) => {
    //     if (val === 0) {
    //       return (
    //         <span>
    //           <strong>the same amount</strong> invested in civilian firearm companies
    //         </span>
    //       )
    //     }
    //     return (
    //       <span>
    //         <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in civilian firearm companies
    //       </span>
    //     )
    //   }
    // },
    // gm_weight: {
    //   id: 'gm_weight',
    //   icon: 'icons_step4',
    //   fieldLabel: 'gm_weight',
    //   benchLabel: 'gm_weight',
    //   valueLabel: 'Gun manufacturers',
    //   direction: 'ascending',
    //   page: 'gun-manufacturer-investments',
    //   label: 'in gun manufacturers',
    //   units: null,
    //   unitsExpanded: null,
    //   diffGood: (diff) => (diff < 0),
    //   diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
    //   moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
    //   format : (val) => format.perc(val),
    //   formatExpanded: (val, moreLess, postiveNegative, url) => {
    //     if (val === 0) {
    //       return (
    //         <span>
    //           <strong>the same amount</strong> invested in gun manufacturers
    //         </span>
    //       )
    //     }
    //     return (
    //       <span>
    //         <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in gun manufacturers
    //       </span>
    //     )
    //   }
    // },
    // gr_weight: {
    //   id: 'gr_weight',
    //   icon: 'icons_step4',
    //   fieldLabel: 'gr_weight',
    //   benchLabel: 'gr_weight',
    //   valueLabel: 'Major gun retailers',
    //   direction: 'ascending',
    //   page: 'gun-retailers-investments',
    //   label: 'in major gun retailers',
    //   units: null,
    //   unitsExpanded: null,
    //   diffGood: (diff) => (diff < 0),
    //   diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
    //   moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
    //   format : (val) => format.perc(val),
    //   formatExpanded: (val, moreLess, postiveNegative, url) => {
    //     if (val === 0) {
    //       return (
    //         <span>
    //           <strong>the same amount</strong> invested in major gun retailers
    //         </span>
    //       )
    //     }
    //     return (
    //       <span>
    //         <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in major gun retailers
    //       </span>
    //     )
    //   }
    // },
  }
}

export default EsgConfig